export default "../css/3ebdff4150d19ed7470705afcdab6856.ttf";